module.exports = {
	following: "Following",
	followers: "Followers",
	friends: "Friends",
	currentLevel: "Current level",
	nextLevel:
		"Get in the top 4 of the weekly leaderboard to advance to the next level",
}